import { render } from "./MdEditIcon.vue?vue&type=template&id=08ddaefa"
import script from "./MdEditIcon.vue?vue&type=script&lang=js"
export * from "./MdEditIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__